import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { IDriverGridState } from '../../types/stateTypes';
import { IDriverGridProps } from '../../types/propTypes';
import Table from '../../components/table/Table';
import DriverService from '../../services/driver/driver-service';
import StandardResponse from '../../models/standard-response';
import {
    IDriverList,
    IDriverDetailSearch,
    IDriverPaymentDetails,
    IDriverReferralData,
    IBalanceDetails,
} from '../../models/driver';
import { Common } from '../../utils/constants';
import { SelectBox, ReactstrapInput } from '../../components/reactstrap-formik';
import DriverGroupService from '../../services/driverGroup/driverGroup-service';
import { IDriverGroupList } from '../../models/driverGroup';
import OrganisationService from '../../services/organisation/organisations-service';
import { IOrganisationList } from '../../models/organisation';
import ability, { Can } from '../../ability';
import { IDriverPromotionList } from '../../models/driver-promotion';
import DriverPromotionService from '../../services/driver-promotion/driverPrmotion-service';
import { regionDateAndTime, trimString } from '../../utils/index';
import RFIDCardsModal from './RFIDCardsModal';
import { Formik, Field } from 'formik';
import { DriverPasswordResetValidationSchema } from '../../validation/driver/driver-validation';
import images from '../../assets/images/index';
import { store } from '../../store';
import { getFormattedCurrencyWithSymbol } from '../../components/common/LocalNumberFormat';
import AddNotesModal from './AddNotesModal';
import CancelPendingTransactionsModal from './CancelPendingTransactionsModal';

export class DriversGrid extends Component<IDriverGridProps, IDriverGridState> {
    private organisationService: OrganisationService;
    private driverService: DriverService;
    private driverGroupService: DriverGroupService;
    private driverPromotionService: DriverPromotionService;
    private defaultStatus: Array<any> = [];
    constructor(props) {
        super(props);

        this.state = {
            drivers: [],
            columns: [],
            referralGridColumns: [],
            totalCount: 0,
            model: {
                showModel: false,
                header: '',
                body: '',
                callBack: null,
            },
            selectOption: {
                status: [],
                group: [],
                tags: [],
                account_type: [],
                payment_type: [],
                organisation: [],
                promotion: [],
            },
            search: {
                full_name: null,
                payment_card: null,
                email: null,
                status: [Common.DriverStatus.ENABLE],
                account_type: null,
                payment_type: null,
                groupIds: null,
                organisationId: null,
                tags: null,
                referral_code: null,
                promotionId: null,
                vehicle_number: null,
                rfid_no: null,
                address: null,
            },
            referralDetailModel: {
                details: null,
                showModel: false,
                id: null,
            },
            balanceDetailModel: {
                details: null,
                showModel: false,
                id: null,
                driverDetails: {},
            },
            referralGridCurrentPage: 1,
            referralGridOffset: 0,
            referralGridRowsPerPage: 10,
            showRFIDCardModal: false,
            showCancelPendingTransactionsModal: false,
            driverId: null,
            showResetPasswordModal: false,
            selectedDriverForPasswordReset: '',
            passwordResetForm: {
                password: '',
            },
            addNotesModal: {
                showModal: false,
                driverDetails: null,
            },
        };
        this.organisationService = new OrganisationService();
        this.driverService = new DriverService();
        this.driverGroupService = new DriverGroupService();
        this.driverPromotionService = new DriverPromotionService();
    }
    async componentDidMount() {
        const { t } = this.props;
        const { selectOption } = this.state;
        this.defaultStatus = [
            {
                label: t('driver.label.enabled'),
                value: Common.DriverStatus.ENABLE,
            },
        ];

        const statusList = [
            {
                label: t('driver.label.enabled'),
                value: Common.DriverStatus.ENABLE,
            },
            {
                label: t('driver.label.disabled'),
                value: Common.DriverStatus.DISABLE,
            },
            {
                label: t('driver.label.cancelled'),
                value: Common.DriverStatus.CANCELLED,
            },
            {
                label: t('driver.label.deleted'),
                value: Common.DriverStatus.DELETED,
            },
            {
                label: t('driver.label.pending'),
                value: Common.DriverStatus.PENDING,
            },
            {
                label: t('driver.label.onstop'),
                value: Common.DriverStatus.ONSTOP,
            },
            {
                label: t('driver.label.badDebtor'),
                value: Common.DriverStatus.BAD_DEBTOR,
            },
            {
                label: t('driver.label.fakeAccount'),
                value: Common.DriverStatus.FAKE_ACCOUNT,
            },
        ];

        const accountTypeList = [
            {
                label: t('driver.account_type.driver'),
                value: Common.DriverAccountType.DRIVER,
            },
            {
                label: t('driver.account_type.vehicle'),
                value: Common.DriverAccountType.VEHICLE,
            },
        ];

        const paymentTypeList = [
            {
                label: t('driver.payment_type.credit_account'),
                value: Common.DriverPaymentType.CREDIT_ACCOUNT,
            },
            {
                label: t('driver.payment_type.prepayment_account'),
                value: Common.DriverPaymentType.PREPAYMENT_ACCOUNT,
            },
        ];
        const referralGridheader = [
            {
                label: t('driver.label.referrer_name'),
                id: 'referrer_name',
                sortable: false,
                isVisible: true,
                cell: (row: any) => {
                    return (
                        <span className="d-block text-nowrap-normal" title={row.referrer_name}>
                            {row.referrer_name}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.referee_Name'),
                id: 'referral_name',
                sortable: false,
                isVisible: true,
                cell: (row: any) => {
                    return (
                        <span className="d-block text-nowrap-normal" title={row.referral_name}>
                            {row.referral_name}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.referral_bonus'),
                id: 'referral_bonus',
                sortable: false,
                isVisible: true,
                cell: (row: any) => {
                    if (row.referral_bonus || row.referral_bonus === 0) {
                        return (
                            <span>
                                {getFormattedCurrencyWithSymbol(
                                    row.referral_bonus?.toString(),
                                    'text',
                                    undefined,
                                    row?.currency_details
                                        ? row?.currency_details?.symbol
                                        : store?.getState()?.configuration?.default_currency?.symbol,
                                )}
                            </span>
                        );
                    }
                    return null;
                },
            },
            {
                label: t('driver.label.referralBonusStatus'),
                id: 'first_charge_status',
                sortable: false,
                isVisible: true,
                style: { textTransform: 'capitalize' },
            },
        ];
        const header = [
            {
                label: t('driver.label.name'),
                id: 'full_name',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    return (
                        <span className="d-block text-nowrap-normal" title={row.full_name}>
                            {row.full_name}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.referral_code'),
                id: 'referral_code',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    if (row.referral_code) {
                        return row.referral_code;
                    }
                    return '-';
                },
            },
            {
                label: t('driver.label.vehicleNumber'),
                id: 'vehicle_number',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    return (
                        <span className="d-block text-nowrap-normal" title={row.vehicle_number}>
                            {row.vehicle_number}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.email'),
                id: 'email',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    return (
                        <span className="d-block text-nowrap-normal" title={row.email}>
                            {row.email}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.type'),
                id: 'account_type',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    if (row.account_type_details) {
                        return row.account_type_details.name;
                    }
                    return '-';
                },
            },
            {
                label: t('driver.label.payment_type'),
                id: 'payment_type',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    if (row.payment_type_details) {
                        return row.payment_type_details.name;
                    }
                    return '-';
                },
            },
            {
                label: t('driver.label.organization'),
                id: 'organisation',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    if (row.organisation) {
                        return (
                            <span
                                className="d-block text-truncate"
                                style={{ maxWidth: 200 }}
                                title={row.organisation.name}
                            >
                                {row.organisation.name}
                            </span>
                        );
                    }
                    return '-';
                },
            },
            {
                label: t('driver.label.federated_account_type'),
                id: 'federated_account_type',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    if (row.federated_account_type) {
                        return (
                            <span className="d-block text-nowrap-normal" title={row.federated_account_type}>
                                {row.federated_account_type}
                            </span>
                        );
                    }
                    return '-';
                },
            },
            {
                label: t('driver.label.deletionEmailSent'),
                id: 'is_delete_account_warning_email_sent',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    if (row.is_delete_account_warning_email_sent) {
                        return row.is_delete_account_warning_email_sent ? t('driver.label.yes') : '-';
                    }
                    return '-';
                },
            },
            {
                label: t('driver.label.createdDate'),
                id: 'created_date',
                sortable: true,
                isVisible: true,
                cell: (row: IDriverDetailSearch) => {
                    if (row.created_date) {
                        return moment(row.created_date).format(regionDateAndTime().GENERAL_DATE_TIME_FORMAT);
                    }
                    return null;
                },
            },
            {
                label: t('driver.label.status'),
                id: 'status',
                sortable: true,
                isVisible: true,
                cell: (row) => {
                    if (row.on_stop && row.status.code === Common.DriverStatus.ENABLE) {
                        return (
                            <span className="badge badge-info badge-info-onStop">
                                {t('fleetDriverSpendHistory.label.onStop')}
                            </span>
                        );
                    }
                    return (
                        <span className="badge badge-info" style={{ background: row.status.color }}>
                            {row.status.name}
                        </span>
                    );
                },
            },
            {
                label: '',
                id: 'notes',
                sortable: false,
                isVisible:
                    ability.can(Common.Actions.ADD_NOTE, Common.Modules.DRIVERS.ACCOUNTS) ||
                    ability.can(Common.Actions.VIEW_NOTE, Common.Modules.DRIVERS.ACCOUNTS),
                cell: (row: IDriverDetailSearch) => {
                    if (row.has_notes && row.status.code !== Common.DriverStatus.DELETED) {
                        return (
                            <a
                                className="icon pointer"
                                title={t('driver.label.viewNotes')}
                                onClick={() => this.manageAddNotesModal(true, row)}
                            >
                                <img
                                    src={images.notesIconSVG}
                                    alt={t<string>('driver.label.viewNotes')}
                                    className="action-icon-img"
                                />
                            </a>
                        );
                    }
                    return null;
                },
            },
            {
                label: t('driver.label.action'),
                id: 'action',
                sortable: false,
                isVisible:
                    ability.can(Common.Actions.CAN_UPDATE, Common.Modules.DRIVERS.ACCOUNTS) ||
                    ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.TRANSACTIONS),
                style: { width: 80 },
                cell: (row) => {
                    const label =
                        row.status.code === Common.DriverStatus.ENABLE
                            ? t('driver.button.disabled')
                            : t('driver.button.enabled');
                    if (
                        row.status.code !== Common.DriverStatus.ENABLE &&
                        row.status.code !== Common.DriverStatus.DISABLE &&
                        row.status.code !== Common.DriverStatus.PENDING &&
                        row.status.code !== Common.DriverStatus.BAD_DEBTOR &&
                        row.status.code !== Common.DriverStatus.FAKE_ACCOUNT
                    ) {
                        return '';
                    }
                    return row.organisation_id === null ? (
                        <Dropdown className="actions">
                            <Dropdown.Toggle id="actions-dropdown">
                                <img
                                    title={t<string>('driver.button.action')}
                                    className="user-icon"
                                    src={images.dropdownMenuSVG}
                                    alt=""
                                />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="pl-2">
                                <>
                                    {row.status.code !== Common.DriverStatus.FAKE_ACCOUNT && (
                                        <Can I={Common.Actions.CAN_UPDATE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                            <Dropdown.Item
                                                title={t<string>('driver.button.edit')}
                                                onClick={() => {
                                                    this.props.editDriver(row.id);
                                                }}
                                            >
                                                <img src={images.iceditSVG} alt={t<string>('driver.button.edit')} />
                                                {t('driver.button.edit')}
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                                title={label}
                                                onClick={() =>
                                                    this.handleModal(
                                                        row.status.code === Common.DriverStatus.ENABLE
                                                            ? t('driver.message.disableConfirmMesage')
                                                            : t('driver.message.enableConfirmMesage'),
                                                        label,
                                                        () =>
                                                            this.updateDriverStatus(
                                                                row.id,
                                                                row.status.code === Common.DriverStatus.ENABLE
                                                                    ? Common.DriverStatus.DISABLE
                                                                    : Common.DriverStatus.ENABLE,
                                                            ),
                                                    )
                                                }
                                            >
                                                {row.status.code === Common.DriverStatus.ENABLE ? (
                                                    <img src={images.disabledSVG} alt={label} />
                                                ) : (
                                                    <img src={images.enableSVG} alt={label} />
                                                )}
                                                {label}
                                            </Dropdown.Item>
                                        </Can>
                                    )}
                                    {row.payment_type && row.status.code !== Common.DriverStatus.FAKE_ACCOUNT && (
                                        <Can
                                            I={Common.Actions.UPDATE_REFERRAL_CODE_STATUS}
                                            a={Common.Modules.DRIVERS.ACCOUNTS}
                                        >
                                            <Dropdown.Item
                                                title={
                                                    row.referral_code
                                                        ? t('driver.button.disableReferralCode')
                                                        : t('driver.button.enableReferralCode')
                                                }
                                                onClick={() =>
                                                    this.handleModal(
                                                        row.referral_code
                                                            ? t('driver.message.disableReferralCodeConfirmMesage')
                                                            : t('driver.message.enableReferralCodeConfirmMesage'),
                                                        row.referral_code
                                                            ? t('driver.button.disableReferralCode')
                                                            : t('driver.button.enableReferralCode'),
                                                        () =>
                                                            this.updateReferralCodeStatus(
                                                                row.id,
                                                                row.referral_code ? false : true,
                                                            ),
                                                    )
                                                }
                                            >
                                                {row.referral_code ? (
                                                    <img
                                                        src={images.disableReferral}
                                                        alt={
                                                            row.referral_code
                                                                ? t('driver.button.disableReferralCode')
                                                                : t('driver.button.enableReferralCode')
                                                        }
                                                    />
                                                ) : (
                                                    <img
                                                        src={images.enableReferral}
                                                        alt={
                                                            row.referral_code
                                                                ? t('driver.button.disableReferralCode')
                                                                : t('driver.button.enableReferralCode')
                                                        }
                                                    />
                                                )}
                                                {row.referral_code
                                                    ? t('driver.button.disableReferralCode')
                                                    : t('driver.button.enableReferralCode')}
                                            </Dropdown.Item>
                                        </Can>
                                    )}
                                    {row.status.code !== Common.DriverStatus.FAKE_ACCOUNT && (
                                        <Dropdown.Item
                                            title={t<string>('driver.label.viewReferral')}
                                            onClick={() => {
                                                this.handleReferralModel(true, row.id);
                                            }}
                                        >
                                            <img
                                                src={images.promotionsgraySVG}
                                                alt={t<string>('driver.label.viewReferral')}
                                            />
                                            {t('driver.label.viewReferral')}
                                        </Dropdown.Item>
                                    )}

                                    {(row.payment_type_details &&
                                        row.status.code !== Common.DriverStatus.FAKE_ACCOUNT) ||
                                    (ability.can(
                                        Common.Actions.VIEW_DRIVER_DEBT_LETTER_HISTORY,
                                        Common.Modules.DRIVERS.ACCOUNTS,
                                    ) &&
                                        row.status.code !== Common.DriverStatus.FAKE_ACCOUNT) ||
                                    (row.payment_type_details &&
                                        row.payment_type_details.code === Common.DriverPaymentType.CREDIT_ACCOUNT &&
                                        ability.can(
                                            Common.Actions.SEARCH_DRIVER_PAYMENT_CARDS,
                                            Common.Modules.DRIVERS.ACCOUNTS,
                                        )) ? (
                                        <div className="dropdown-item">
                                            <div className="pl-2 custom-drop-div">
                                                <img src={images.dropDownArrowSVG} className="rotate-img" />
                                            </div>
                                            <img
                                                src={images.financialDetailsSVG}
                                                alt={t('driver.label.financialDetails')}
                                                className="financial-details-icon"
                                            />
                                            <Dropdown className="custom-nested-dropdown">
                                                <Dropdown.Toggle
                                                    ref={(el) => {
                                                        if (el) {
                                                            el.style.setProperty('border', 'none', 'important');
                                                            el.style.setProperty('border-radius', '0px', 'important');
                                                            el.style.setProperty(
                                                                'background-color',
                                                                'transparent',
                                                                'important',
                                                            );
                                                            el.style.setProperty('margin', '0', 'important');
                                                            el.style.setProperty('position', 'relative', 'important');
                                                            el.style.setProperty('margin-left', '-35px', 'important');
                                                            el.style.setProperty('padding-left', '35px', 'important');
                                                            el.style.setProperty('font-weight', '400', 'important');
                                                        }
                                                    }}
                                                >
                                                    {t('driver.label.financialDetails')}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu flip={false} className="custom-drop-menu">
                                                    {row.payment_type_details &&
                                                    row.payment_type_details.code ===
                                                        Common.DriverPaymentType.CREDIT_ACCOUNT ? (
                                                        <>
                                                            <Can
                                                                I={Common.Actions.SEARCH_DRIVER_PAYMENT_CARDS}
                                                                a={Common.Modules.DRIVERS.ACCOUNTS}
                                                            >
                                                                <Dropdown.Item
                                                                    title={t('driver.label.paymentCard')}
                                                                    as={Link}
                                                                    to={{
                                                                        pathname: `/drivers/${row.id}/payment-cards`,
                                                                    }}
                                                                    target="_blank"
                                                                >
                                                                    <img
                                                                        src={images.transactionsbSVG}
                                                                        alt={t<string>('driver.label.paymentCard')}
                                                                    />
                                                                    {t('driver.label.paymentCard')}
                                                                </Dropdown.Item>
                                                            </Can>
                                                        </>
                                                    ) : (
                                                        <></>
                                                    )}
                                                    {row.payment_type_details !== null &&
                                                        row.status.code !== Common.DriverStatus.FAKE_ACCOUNT && (
                                                            <Dropdown.Item
                                                                title={t<string>('driver.label.balanceDetails')}
                                                                onClick={() => {
                                                                    this.handleBalanceModel(true, row);
                                                                }}
                                                            >
                                                                <img
                                                                    src={images.payment_graySVG}
                                                                    alt={t<string>('driver.label.balanceDetails')}
                                                                />
                                                                {t('driver.label.balanceDetails')}
                                                            </Dropdown.Item>
                                                        )}

                                                    {row.authorized_unsettled_balance &&
                                                    row.authorized_unsettled_balance > 0 ? (
                                                        <Can
                                                            I={Common.Actions.CANCEL_PENDING_TRANSACTIONS}
                                                            a={Common.Modules.DRIVERS.ACCOUNTS}
                                                        >
                                                            <Dropdown.Item
                                                                title={t('driver.label.cancelPendingTransactions')}
                                                                onClick={() =>
                                                                    this.setState({
                                                                        ...this.state,
                                                                        showCancelPendingTransactionsModal: true,
                                                                        driverId: row.id,
                                                                    })
                                                                }
                                                            >
                                                                <img
                                                                    src={images.cancelPendingTransactionSVG}
                                                                    alt={t('driver.label.cancelPendingTransactions')}
                                                                />
                                                                {t('driver.label.cancelPendingTransactions')}
                                                            </Dropdown.Item>
                                                        </Can>
                                                    ) : (
                                                        <></>
                                                    )}
                                                    {row.status.code !== Common.DriverStatus.FAKE_ACCOUNT && (
                                                        <Can
                                                            I={Common.Actions.VIEW_DRIVER_DEBT_LETTER_HISTORY}
                                                            a={Common.Modules.DRIVERS.ACCOUNTS}
                                                        >
                                                            <Dropdown.Item
                                                                title={t<string>('driver.button.debtLetterHistory')}
                                                                onClick={() => {
                                                                    this.props.showDebtLetterHistoryPage(row);
                                                                }}
                                                            >
                                                                <img
                                                                    src={images.letterHistorySVG}
                                                                    className="letter-history-icon"
                                                                    alt={t<string>('driver.button.debtLetterHistory')}
                                                                />
                                                                {t('driver.button.debtLetterHistory')}
                                                            </Dropdown.Item>
                                                        </Can>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    {row.status.code !== Common.DriverStatus.FAKE_ACCOUNT && (
                                        <Dropdown.Item
                                            title={t<string>('driver.label.rfidCard')}
                                            onClick={() =>
                                                this.setState({
                                                    ...this.state,
                                                    showRFIDCardModal: true,
                                                    driverId: row.id,
                                                })
                                            }
                                        >
                                            <img
                                                src={images.rfidcardsgreySVG}
                                                alt={t<string>('driver.label.rfidCard')}
                                            />
                                            {t('driver.label.rfidCard')}
                                        </Dropdown.Item>
                                    )}
                                </>

                                <Can I={Common.Actions.CAN_VIEW} a={Common.Modules.DRIVERS.TRANSACTIONS}>
                                    <Dropdown.Item
                                        title={t<string>('driver.button.viewTransactions')}
                                        as={Link}
                                        to={{
                                            pathname: `/drivers/transactions/${row.id}`,
                                            search: `?name=${row.full_name}`,
                                        }}
                                        target="_blank"
                                    >
                                        <img
                                            src={images.transactionsbSVG}
                                            alt={t<string>('driver.button.viewTransactions')}
                                        />
                                        {t('driver.button.viewTransactions')}
                                    </Dropdown.Item>
                                </Can>
                                {row.status.code === Common.DriverStatus.ENABLE && (
                                    <Can I={Common.Actions.START_REMOTE_CHARGE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                        <Dropdown.Item
                                            title={t<string>('driver.button.startCharge')}
                                            onClick={() => {
                                                this.props.startChargePage(row.id, row);
                                            }}
                                        >
                                            <img
                                                src={images.chargingSVG}
                                                alt={t<string>('driver.button.startCharge')}
                                            />
                                            {t('driver.button.startCharge')}
                                        </Dropdown.Item>
                                    </Can>
                                )}
                                {row.status.code === Common.DriverStatus.ENABLE &&
                                    row.account_type_details.code === 'DRIVER' &&
                                    !row.is_federated && (
                                        <Can I={Common.Actions.RESET_PASSWORD} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                            <Dropdown.Item
                                                title={t<string>('driver.button.resetPassword')}
                                                onClick={() => this.resetDriverPassword(row)}
                                            >
                                                <img
                                                    src={images.resetpasswordSVG}
                                                    alt={t<string>('driver.button.resetPassword')}
                                                />
                                                {t('driver.button.resetPassword')}
                                            </Dropdown.Item>
                                        </Can>
                                    )}
                                {(row.account_type_details.code === 'DRIVER' || row.is_federated) && (
                                    <Can I={Common.Actions.CAN_DELETE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                        <Dropdown.Item
                                            title={t<string>('driver.button.delete')}
                                            onClick={() =>
                                                this.handleModal(
                                                    t('driver.message.deleteDriverConfirmMesage'),
                                                    t('driver.button.delete'),
                                                    () => this.deleteDriverAccount(row.id),
                                                )
                                            }
                                        >
                                            <img src={images.deleteSVG} alt={t<string>('driver.button.delete')} />
                                            {t('driver.button.delete')}
                                        </Dropdown.Item>
                                    </Can>
                                )}
                                <Can I={Common.Actions.VIEW_DRIVER_ACTIVITIES} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                    <Dropdown.Item
                                        title={t<string>('driver.button.viewActivities')}
                                        onClick={() => {
                                            this.props.showDriverActivitiesPage(row);
                                        }}
                                    >
                                        <img src={images.icdetailSVG} alt={t<string>('driver.button.viewActivities')} />
                                        {t('driver.button.viewActivities')}
                                    </Dropdown.Item>
                                </Can>
                                {row.status.code !== Common.DriverStatus.FAKE_ACCOUNT && (
                                    <>
                                        <Can
                                            I={Common.Actions.MANAGE_PREMIUM_SUBSCRIPTIONS}
                                            a={Common.Modules.DRIVERS.ACCOUNTS}
                                        >
                                            <Dropdown.Item
                                                title={t<string>('driver.button.premiumSubscriptions')}
                                                as={Link}
                                                to={{
                                                    pathname: `/drivers/premium-subscriptions/${row.id}`,
                                                }}
                                                target="_blank"
                                            >
                                                <img
                                                    src={images.subscriptionSVG}
                                                    alt={t<string>('driver.button.premiumSubscriptions')}
                                                />
                                                {t('driver.button.premiumSubscriptions')}
                                            </Dropdown.Item>
                                        </Can>
                                    </>
                                )}

                                {(row.status.code === Common.DriverStatus.ENABLE ||
                                    row.status.code === Common.DriverStatus.DISABLE ||
                                    row.status.code === Common.DriverStatus.BAD_DEBTOR) &&
                                    (row.account_type_details.code === Common.DriverAccountType.DRIVER ||
                                        row.is_federated) && (
                                        <Can
                                            I={Common.Actions.MARK_AS_FAKE_ACCOUNT}
                                            a={Common.Modules.DRIVERS.ACCOUNTS}
                                        >
                                            <Dropdown.Item
                                                title={t<string>('driver.button.markAsFake')}
                                                onClick={() =>
                                                    this.handleModal(
                                                        t('driver.message.markAsFakeConfirmMessage'),
                                                        t('driver.button.markAsFake'),
                                                        () =>
                                                            this.updateDriverStatus(
                                                                row.id,
                                                                Common.DriverStatus.FAKE_ACCOUNT,
                                                            ),
                                                    )
                                                }
                                            >
                                                <img
                                                    src={images.fakeAccountSVG}
                                                    alt={t<string>('driver.button.markAsFake')}
                                                />
                                                {t('driver.button.markAsFake')}
                                            </Dropdown.Item>
                                        </Can>
                                    )}

                                <Can I={Common.Actions.ADD_NOTE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                    <Dropdown.Item
                                        title={t<string>('driver.button.addNotes')}
                                        onClick={() => this.manageAddNotesModal(true, row)}
                                    >
                                        <img src={images.addNoteSVG} alt={t<string>('driver.button.addNotes')} />
                                        {t('driver.button.addNotes')}
                                    </Dropdown.Item>
                                </Can>
                            </Dropdown.Menu>
                        </Dropdown>
                    ) : (
                        <Dropdown className="actions">
                            <Dropdown.Toggle id="actions-dropdown">
                                <img
                                    title={t<string>('driver.button.action')}
                                    className="user-icon"
                                    src={images.dropdownMenuSVG}
                                    alt=""
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Can I={Common.Actions.CAN_UPDATE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                    <Dropdown.Item
                                        title={
                                            row.status.code === Common.DriverStatus.ENABLE ||
                                            row.status.code === Common.DriverStatus.PENDING
                                                ? t<string>('driver.button.disabled')
                                                : t<string>('driver.button.enabled')
                                        }
                                        onClick={() =>
                                            this.handleModal(
                                                row.status.code === Common.DriverStatus.ENABLE ||
                                                    row.status.code === Common.DriverStatus.PENDING
                                                    ? t('driver.message.disableConfirmMesage')
                                                    : t('driver.message.enableConfirmMesage'),
                                                label,
                                                () =>
                                                    this.updateDriverStatus(
                                                        row.id,
                                                        row.status.code === Common.DriverStatus.ENABLE ||
                                                            row.status.code === Common.DriverStatus.PENDING
                                                            ? Common.DriverStatus.DISABLE
                                                            : Common.DriverStatus.ENABLE,
                                                    ),
                                            )
                                        }
                                    >
                                        {row.status.code === Common.DriverStatus.ENABLE ||
                                        row.status.code === Common.DriverStatus.PENDING ? (
                                            <img src={images.disabledSVG} alt={label} />
                                        ) : (
                                            <img src={images.enableSVG} alt={label} />
                                        )}
                                        {row.status.code === Common.DriverStatus.ENABLE ||
                                        row.status.code === Common.DriverStatus.PENDING
                                            ? t('driver.button.disabled')
                                            : t('driver.button.enabled')}
                                    </Dropdown.Item>
                                </Can>
                                {row.status.code !== Common.DriverStatus.PENDING && (
                                    <Dropdown.Item
                                        title={t<string>('driver.label.rfidCard')}
                                        onClick={() =>
                                            this.setState({ ...this.state, showRFIDCardModal: true, driverId: row.id })
                                        }
                                    >
                                        <img src={images.rfidcardsgreySVG} alt={t<string>('driver.label.rfidCard')} />
                                        {t('driver.label.rfidCard')}
                                    </Dropdown.Item>
                                )}

                                {row.status.code === Common.DriverStatus.ENABLE && (
                                    <Can I={Common.Actions.START_REMOTE_CHARGE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                        <Dropdown.Item
                                            title={t<string>('driver.button.startCharge')}
                                            onClick={() => {
                                                this.props.startChargePage(row.id, row);
                                            }}
                                        >
                                            <img
                                                src={images.chargingSVG}
                                                alt={t<string>('driver.button.startCharge')}
                                            />
                                            {t('driver.button.startCharge')}
                                        </Dropdown.Item>
                                    </Can>
                                )}
                                {row.status.code === Common.DriverStatus.ENABLE &&
                                    row.account_type_details.code === 'FLEET_DRIVER' &&
                                    !row.is_federated && (
                                        <Can I={Common.Actions.RESET_PASSWORD} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                            <Dropdown.Item
                                                title={t<string>('driver.button.resetPassword')}
                                                onClick={() => this.resetDriverPassword(row)}
                                            >
                                                <img
                                                    src={images.resetpasswordSVG}
                                                    alt={t<string>('driver.button.resetPassword')}
                                                />
                                                {t('driver.button.resetPassword')}
                                            </Dropdown.Item>
                                        </Can>
                                    )}
                                {row.status.code !== Common.DriverStatus.PENDING &&
                                    row.account_type_details.code === 'FLEET_DRIVER' && (
                                        <Can
                                            I={Common.Actions.VIEW_DRIVER_ACTIVITIES}
                                            a={Common.Modules.DRIVERS.ACCOUNTS}
                                        >
                                            <Dropdown.Item
                                                title={t<string>('driver.button.viewActivities')}
                                                onClick={() => {
                                                    this.props.showDriverActivitiesPage(row);
                                                }}
                                            >
                                                <img
                                                    src={images.icdetailSVG}
                                                    alt={t<string>('driver.button.viewActivities')}
                                                />
                                                {t('driver.button.viewActivities')}
                                            </Dropdown.Item>
                                        </Can>
                                    )}
                                <Can I={Common.Actions.CAN_DELETE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                    <Dropdown.Item
                                        title={t<string>('driver.button.delete')}
                                        onClick={() =>
                                            this.handleModal(
                                                t('driver.message.deleteDriverConfirmMesage'),
                                                t('driver.button.delete'),
                                                () => this.deleteDriverAccount(row.id),
                                            )
                                        }
                                    >
                                        <img src={images.deleteSVG} alt={t<string>('driver.button.delete')} />
                                        {t('driver.button.delete')}
                                    </Dropdown.Item>
                                </Can>
                                <Can I={Common.Actions.ADD_NOTE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                                    <Dropdown.Item
                                        title={t<string>('driver.button.addNotes')}
                                        onClick={() => this.manageAddNotesModal(true, row)}
                                    >
                                        <img src={images.addNoteSVG} alt={t<string>('driver.button.addNotes')} />
                                        {t('driver.button.addNotes')}
                                    </Dropdown.Item>
                                </Can>
                            </Dropdown.Menu>
                        </Dropdown>
                    );
                },
            },
        ];
        const tagList = await this.getDriverTagList();
        const promotionList = await this.getDriverPromotionList();
        const driverGroups = await this.getDriverGroupList();
        const organizationList = await this.getOrganisationList();
        this.setState(
            {
                columns: header,
                referralGridColumns: referralGridheader,
                selectOption: {
                    ...selectOption,
                    status: statusList,
                    account_type: accountTypeList,
                    payment_type: paymentTypeList,
                    group: driverGroups,
                    organisation: organizationList,
                    tags: tagList,
                    promotion: promotionList,
                },
            },
            () => {
                this.syncSearch().then(async () => {
                    const usersList = await this.getDriversList();
                    this.setState({
                        drivers: usersList,
                    });
                });
            },
        );
    }
    getDriverPromotionList = async () => {
        const promotionsList: Array<any> = [];
        await this.driverPromotionService
            .getDriverPromotionList({ status: ['ENABLE'], for_organisations: false, order: [['name', 'asc']] })
            .then(async (res: StandardResponse<IDriverPromotionList>) => {
                res.Data.rows.forEach((item) => {
                    promotionsList.push({
                        color: '#00B8D9',
                        value: item.id,
                        label:
                            item.expiry_date !== null &&
                            moment(item.expiry_date).diff(moment(new Date(), 'YYYY-MM-DD'), 'days') < 0
                                ? item.name + ' (' + item.code + ')' + this.props.t('driver.label.expired')
                                : item.name + ' (' + item.code + ')',
                    });
                });
            })

            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();

        return promotionsList;
    };
    getOrganisationList = async () => {
        let organisationList: Array<any> = [];
        const filterInput = {
            status: [Common.OrganisationsStatus.ENABLE],
            order: [['name', 'asc']],
        };
        await this.organisationService
            .getOrganisationList(filterInput)
            .then(async (res: StandardResponse<IOrganisationList>) => {
                organisationList = res.Data.rows;
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return organisationList;
    };
    getDriverTagList = async () => {
        let driverGroupList = [];
        await this.driverService
            .getDriverTags()
            .then(async (res: StandardResponse<any>) => {
                driverGroupList = res.Data.rows;
            })

            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();

        return driverGroupList;
    };
    getDriverGroupList = async () => {
        let driverGroupList: Array<any> = [];
        await this.driverGroupService
            .searchDriverGroup({ order: [['name', 'asc']] })
            .then(async (res: StandardResponse<IDriverGroupList>) => {
                driverGroupList = res.Data.rows;
            })

            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();

        return driverGroupList;
    };
    getDriversList = async () => {
        const { search } = this.state;
        const { rowsPerPage, offset, sortColumn, sortOrder } = this.props.filterState;

        let usersList: Array<any> = [];
        const filterInput = _.pickBy(search, (value) => {
            return !_.isEmpty(value);
        });
        if (search.promotionId !== null) {
            Object.assign(filterInput, {
                promotionId: search.promotionId,
            });
        }
        Object.assign(filterInput, {
            limit: rowsPerPage,
            offset: offset,
            order: [[sortColumn, sortOrder]],
        });
        await this.driverService
            .getDriverList(filterInput)
            .then(async (res: StandardResponse<IDriverList>) => {
                usersList = res.Data.rows;
                this.setState({ totalCount: res.Data.count });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return usersList;
    };
    getPaymentDetails = async (id: number) => {
        let details;
        await this.driverService
            .getPaymentDetails(id)
            .then(async (res: StandardResponse<IDriverPaymentDetails>) => {
                details = res.Data;
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return details;
    };
    getReferralDetails = async (id: number) => {
        let details;
        const filterInput = {
            limit: this.state.referralGridRowsPerPage,
            offset: this.state.referralGridOffset,
        };
        await this.driverService
            .getReferralDetails(id, filterInput)
            .then(async (res: StandardResponse<IDriverReferralData>) => {
                details = res.Data;
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return details;
    };
    getBalanceDetails = async (id: number) => {
        let details;
        await this.driverService
            .getBalanceDetails(id)
            .then(async (res: StandardResponse<IBalanceDetails>) => {
                details = res.Data;
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return details;
    };
    updateDriverStatus = async (id: number, status: string) => {
        await this.driverService
            .updateDriverStatus(id, { status: status })
            .then(async (res: StandardResponse<number>) => {
                toast.success(res.Messages);
                this.setState({
                    model: {
                        showModel: false,
                        header: '',
                        body: '',
                        callBack: null,
                    },
                });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        const usersList = await this.getDriversList();
        this.setState({
            drivers: usersList,
            model: {
                showModel: false,
                header: '',
                body: '',
                callBack: null,
            },
        });
    };
    updateReferralCodeStatus = async (id: number, is_referral_code_active: boolean) => {
        await this.driverService
            .updateReferralCodeStatus(id, { is_referral_code_active: is_referral_code_active })
            .then(async (res: StandardResponse<number>) => {
                toast.success(res.Messages);
                this.setState({
                    model: {
                        showModel: false,
                        header: '',
                        body: '',
                        callBack: null,
                    },
                });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        const usersList = await this.getDriversList();
        this.setState({
            drivers: usersList,
            model: {
                showModel: false,
                header: '',
                body: '',
                callBack: null,
            },
        });
    };
    handleChange = (event) => {
        const { searchForm } = this.props.filterState;
        this.props.updateFilterState({
            searchForm: {
                ...searchForm,
                [event.target.name]: event.target.value,
            },
        });
    };
    handleChangeDropdown = (name, option) => {
        const { searchForm } = this.props.filterState;

        this.props.updateFilterState({
            searchForm: {
                ...searchForm,
                [name]: option,
            },
        });
    };

    syncSearch = (): Promise<boolean> => {
        return new Promise((resolve) => {
            const { search } = this.state;
            const { searchForm } = this.props.filterState;

            search.full_name = !_.isEmpty(searchForm.driver_name) ? trimString(searchForm.driver_name) : null;
            search.payment_card = !_.isEmpty(searchForm.payment_card) ? trimString(searchForm.payment_card) : null;
            search.email = !_.isEmpty(searchForm.driver_email) ? trimString(searchForm.driver_email) : null;
            search.referral_code = !_.isEmpty(searchForm.referral_code) ? trimString(searchForm.referral_code) : null;
            search.vehicle_number = !_.isEmpty(searchForm.vehicle_number)
                ? trimString(searchForm.vehicle_number)
                : null;
            search.account_type = !_.isEmpty(searchForm.account_type) ? (searchForm.account_type as any).value : null;
            search.payment_type = !_.isEmpty(searchForm.payment_type) ? (searchForm.payment_type as any).value : null;
            search.organisationId = !_.isEmpty(searchForm.organisation)
                ? (searchForm.organisation as any).id.toString()
                : null;
            search.promotionId = !_.isEmpty(searchForm.promotion) ? searchForm.promotion.value : null;
            search.rfid_no = !_.isEmpty(searchForm.rfid_no) ? trimString(searchForm.rfid_no) : null;
            search.address = !_.isEmpty(searchForm.address) ? trimString(searchForm.address) : null;

            search.status = [];
            if (_.isArray(searchForm.status)) {
                searchForm.status.forEach((item) => {
                    search.status.push(item.value);
                });
            }
            search.groupIds = [];
            if (_.isArray(searchForm.groups)) {
                searchForm.groups.forEach((item) => {
                    (search as any).groupIds.push(item.id);
                });
            }
            search.tags = [];
            if (_.isArray(searchForm.tags)) {
                searchForm.tags.forEach((item) => {
                    (search as any).tags.push(item.name);
                });
            }
            this.setState({ search }, async () => {
                resolve(true);
            });
        });
    };

    handleSearch = async () => {
        this.props.updateFilterState(
            {
                offset: 0,
                currentPage: 1,
            },
            () => {
                this.syncSearch().then(async () => {
                    const usersList = await this.getDriversList();
                    this.setState({
                        drivers: usersList,
                    });
                });
            },
        );
    };

    handleReset = async () => {
        const searchForm = {
            driver_email: '',
            driver_name: '',
            referral_code: '',
            account_type: '',
            payment_type: '',
            organisation: '',
            payment_card: '',
            groups: [],
            tags: [],
            status: this.defaultStatus,
            promotion: null,
            vehicle_number: '',
            rfid_no: '',
            address: '',
        };
        this.props.updateFilterState({ searchForm, currentPage: 1, offset: 0 }, () => {
            this.syncSearch().then(async () => {
                const usersList = await this.getDriversList();
                this.setState({
                    drivers: usersList,
                });
            });
        });
    };
    handleSorting = async (columnName: string) => {
        const { sortColumn } = this.props.filterState;
        let sortOrder = this.props.filterState.sortOrder;
        if (sortColumn === columnName) {
            sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
        } else {
            sortOrder = 'asc';
        }

        this.props.updateFilterState({ sortOrder, sortColumn: columnName }, () => {
            this.syncSearch().then(async () => {
                const usersList = await this.getDriversList();
                this.setState({
                    drivers: usersList,
                });
            });
        });
    };
    handlePageChange = async (currentPage: number, rowsPerPage: number) => {
        const offset = (currentPage - 1) * rowsPerPage;

        this.props.updateFilterState({ currentPage, rowsPerPage, offset }, () => {
            this.syncSearch().then(async () => {
                const usersList = await this.getDriversList();
                this.setState({
                    drivers: usersList,
                });
            });
        });
    };
    handleModal = (body: string, header: string, callBack: Function | null) => {
        this.setState({
            model: {
                body: body,
                header: header,
                callBack: callBack,
                showModel: !this.state.model.showModel,
            },
        });
    };
    handleReferralModel = async (showModel: boolean, id: number | null) => {
        let referralDetails = null;
        if (showModel) {
            referralDetails = await this.getReferralDetails(id!);
        }
        this.setState({
            referralDetailModel: {
                showModel,
                details: referralDetails,
                id,
            },
            referralGridCurrentPage: 1,
            referralGridRowsPerPage: 10,
            referralGridOffset: 0,
        });
    };
    handleBalanceModel = async (showModel: boolean, driver: any) => {
        let details = null;
        if (showModel) {
            details = await this.getBalanceDetails(driver?.id);
        }
        this.setState({
            balanceDetailModel: {
                showModel,
                details: details,
                id: driver?.id,
                driverDetails: driver,
            },
        });
    };

    handleReferralPageChange = async (currentPage: number, rowsPerPage: number) => {
        const offset = (currentPage - 1) * rowsPerPage;
        this.setState(
            {
                referralGridCurrentPage: currentPage,
                referralGridRowsPerPage: rowsPerPage,
                referralGridOffset: offset,
            },
            async () => {
                const data = await this.getReferralDetails(this.state.referralDetailModel.id!);
                this.setState({
                    referralDetailModel: {
                        ...this.state.referralDetailModel,
                        details: data,
                    },
                });
            },
        );
    };
    closeModal = () => {
        this.setState({
            showRFIDCardModal: false,
        });
    };

    closeCancelPendingTransactionsModal = () => {
        this.setState({
            showCancelPendingTransactionsModal: false,
        });
    };
    resetDriverPassword = async (row) => {
        this.setState({ showResetPasswordModal: true, selectedDriverForPasswordReset: row });
    };
    closeResetPasswordModal = () => {
        this.setState({ showResetPasswordModal: false });
    };
    onConfirmResetPassword = async (values) => {
        const obj = {
            password: values.password,
        };
        let driverId = null;
        if (this.state.selectedDriverForPasswordReset) {
            driverId = this.state.selectedDriverForPasswordReset.id;
        }
        await this.driverService
            .resetDriverPassword(driverId!, obj)
            .then(async (res: StandardResponse<number>) => {
                toast.success(res.Messages);
                const usersList = await this.getDriversList();
                this.setState({
                    drivers: usersList,
                    showResetPasswordModal: false,
                });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
                this.setState({ showResetPasswordModal: false });
            });
    };

    deleteDriverAccount = async (driverId) => {
        await this.driverService
            .deleteDriverAccount(driverId)
            .then(async (res: StandardResponse<number>) => {
                toast.success(res.Messages);
                this.setState({
                    model: {
                        showModel: false,
                        header: '',
                        body: '',
                        callBack: null,
                    },
                });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        const usersList = await this.getDriversList();
        this.setState({
            drivers: usersList,
            model: {
                showModel: false,
                header: '',
                body: '',
                callBack: null,
            },
        });
    };

    cancelPendingTransactions = async (driverId: number, data: Array<number>) => {
        const input = {
            transaction_ids: data,
        };
        await this.driverService
            .cancelPendingTransaction(driverId, input)
            .then((res) => {
                toast.success(res.Messages);
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        const usersList = await this.getDriversList();
        this.setState({
            drivers: usersList,
            showCancelPendingTransactionsModal: false,
        });
    };

    manageAddNotesModal = async (showModal: boolean, driverDetails: IDriverDetailSearch | null = null) => {
        if (!showModal) {
            const usersList = await this.getDriversList();
            this.setState({ drivers: usersList });
        }
        this.setState({ ...this.state, addNotesModal: { showModal, driverDetails } });
    };

    render() {
        const { t } = this.props;
        const { selectOption } = this.state;
        const { searchForm, rowsPerPage, currentPage, sortColumn, sortOrder } = this.props.filterState;

        return (
            <>
                <div className="title row align-items-content justify-content-between pb-3">
                    <div className="col-auto col-sm text-truncate pr-0">
                        <h1 className="text-truncate">{t('driver.header')}</h1>
                    </div>
                </div>

                <div className="card-outer">
                    <div className="pt-3 pl-3 pr-3">
                        <form
                            noValidate
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSearch();
                            }}
                            autoComplete="off"
                        >
                            <div className="row">
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="driver_name"
                                        value={searchForm.driver_name}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t<string>('driver.placeholder.name')}
                                        autoComplete="new-driver-name"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="driver_email"
                                        maxLength={50}
                                        value={searchForm.driver_email}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t<string>('driver.placeholder.email')}
                                        autoComplete="new-driver-email"
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="account_type"
                                        class="form-control"
                                        value={searchForm.account_type}
                                        isMulti={false}
                                        options={selectOption.account_type}
                                        onChange={(e) => this.handleChangeDropdown('account_type', e)}
                                        getOptionLabel={(opt) => opt.label}
                                        getOptionValue={(opt) => opt.value}
                                        isClearable={true}
                                        placeholder={t('driver.placeholder.select.account_type')}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="payment_type"
                                        class="form-control"
                                        value={searchForm.payment_type}
                                        isMulti={false}
                                        options={selectOption.payment_type}
                                        onChange={(e) => this.handleChangeDropdown('payment_type', e)}
                                        getOptionLabel={(opt) => opt.label}
                                        getOptionValue={(opt) => opt.value}
                                        isClearable={true}
                                        placeholder={t('driver.placeholder.select.payment_type')}
                                    />
                                </div>

                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="referral_code"
                                        value={searchForm.referral_code}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t<string>('driver.placeholder.referral_code')}
                                        autoComplete="off"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="organisation"
                                        class="form-control"
                                        value={searchForm.organisation}
                                        isMulti={false}
                                        options={selectOption.organisation}
                                        onChange={(e) => this.handleChangeDropdown('organisation', e)}
                                        getOptionLabel={(opt) => opt.name}
                                        getOptionValue={(opt) => opt.id}
                                        isClearable={true}
                                        placeholder={t('driver.placeholder.select.organization')}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="groups"
                                        class="form-control"
                                        value={searchForm.groups}
                                        isMulti={true}
                                        options={selectOption.group}
                                        onChange={(e) => this.handleChangeDropdown('groups', e)}
                                        getOptionLabel={(opt) => opt.name}
                                        getOptionValue={(opt) => opt.id}
                                        isClearable={false}
                                        placeholder={t('driver.placeholder.select.driver_groups')}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="tags"
                                        class="form-control"
                                        value={searchForm.tags}
                                        isMulti={true}
                                        options={selectOption.tags}
                                        onChange={(e) => this.handleChangeDropdown('tags', e)}
                                        getOptionLabel={(opt) => opt.name}
                                        getOptionValue={(opt) => opt.name}
                                        isClearable={false}
                                        placeholder={t('driver.placeholder.select.driver_tags')}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="promotion"
                                        class="form-control"
                                        value={searchForm.promotion}
                                        isMulti={false}
                                        options={selectOption.promotion}
                                        onChange={(e) => this.handleChangeDropdown('promotion', e)}
                                        getOptionLabel={(opt) => opt.label}
                                        getOptionValue={(opt) => opt.value}
                                        isClearable={true}
                                        placeholder={t('driver.placeholder.select.promotion')}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <SelectBox
                                        name="status"
                                        class="form-control"
                                        value={searchForm.status}
                                        isMulti={true}
                                        options={selectOption.status}
                                        onChange={(e) => this.handleChangeDropdown('status', e)}
                                        getOptionLabel={(opt) => opt.label}
                                        getOptionValue={(opt) => opt.value}
                                        isClearable={false}
                                        placeholder={t('driver.placeholder.select.status')}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="payment_card"
                                        value={searchForm.payment_card}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t<string>('driver.placeholder.payment_card')}
                                        autoComplete="off"
                                        maxLength={4}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="vehicle_number"
                                        value={searchForm.vehicle_number}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t<string>('driver.placeholder.vehicle_number')}
                                        autoComplete="off"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="rfid_no"
                                        value={searchForm.rfid_no}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t<string>('driver.placeholder.publicRFID')}
                                        autoComplete="off"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="address"
                                        value={searchForm.address}
                                        onChange={(e) => this.handleChange(e)}
                                        placeholder={t<string>('driver.placeholder.searchAddress')}
                                        autoComplete="off"
                                        maxLength={100}
                                    />
                                </div>

                                <div className="form-group col-md-auto">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mr-2"
                                        title={t<string>('driver.button.search')}
                                    >
                                        <span>{t('driver.button.search')}</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        title={t<string>('driver.button.reset')}
                                        onClick={this.handleReset}
                                    >
                                        <span>{t('driver.button.reset')}</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <Table
                        columns={this.state.columns}
                        data={this.state.drivers}
                        rowsPerPage={rowsPerPage}
                        currentPage={currentPage}
                        totalCount={this.state.totalCount}
                        sortColumn={sortColumn}
                        sortOrder={sortOrder}
                        handlePageChange={this.handlePageChange}
                        handleSorting={this.handleSorting}
                        t={this.props.t}
                    />
                </div>
                <Modal show={this.state.model.showModel} onHide={() => this.handleModal('', '', null)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.model.header}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.model.body} </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn btn-primary"
                            onClick={() => (this.state.model as any).callBack()}
                            title={t<string>('driver.button.yes')}
                        >
                            <span>{t('driver.button.yes')}</span>
                        </Button>
                        <Button
                            className="btn btn-secondary"
                            onClick={() => this.handleModal('', '', null)}
                            title={t<string>('driver.button.no')}
                        >
                            <span>{t('driver.button.no')}</span>
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="lg"
                    show={this.state.referralDetailModel.showModel}
                    onHide={() => this.handleReferralModel(false, null)}
                >
                    {this.state.referralDetailModel.details !== null &&
                    this.state.referralDetailModel.details !== undefined &&
                    this.state.referralDetailModel.details.referrer &&
                    Object.keys(this.state.referralDetailModel.details.referrer).length > 0 ? (
                        <>
                            <div>
                                <Modal.Header closeButton style={{ float: 'right' }}></Modal.Header>
                                <div>
                                    <div style={{ paddingLeft: '15px', paddingTop: '20px' }}>
                                        <label className="modal-label-bold-text">
                                            {t('driver.label.referrerName')}
                                        </label>
                                        <span>&nbsp;{this.state.referralDetailModel.details.referrer?.name}</span>
                                    </div>
                                    <div style={{ marginTop: '5px', paddingLeft: '15px' }}>
                                        <label className="modal-label-bold-text">
                                            {t('driver.label.referralCode')}
                                        </label>
                                        <span>&nbsp;{this.state.referralDetailModel.details.referrer?.code}</span>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div>
                            <Modal.Header closeButton style={{ float: 'right' }}></Modal.Header>
                            <div style={{ paddingLeft: '15px', paddingTop: '20px' }}>
                                <label className="modal-label-bold-text">{t('driver.label.noReferrerMessage')}</label>
                            </div>
                        </div>
                    )}
                    <Modal.Header>
                        <Modal.Title>{t('driver.label.referralDetails')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.referralDetailModel.details !== null &&
                        this.state.referralDetailModel.details !== undefined &&
                        this.state.referralDetailModel.details.rows?.length > 0 ? (
                            <>
                                <div style={{ overflow: 'auto', maxHeight: 400 }}>
                                    <Table
                                        columns={this.state.referralGridColumns}
                                        data={this.state.referralDetailModel.details.rows}
                                        rowsPerPage={this.state.referralGridRowsPerPage}
                                        currentPage={this.state.referralGridCurrentPage}
                                        totalCount={this.state.referralDetailModel.details.count}
                                        sortColumn=""
                                        sortOrder=""
                                        handlePageChange={this.handleReferralPageChange}
                                        handleSorting={() => {}}
                                        t={this.props.t}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <h6>
                                    <td>{t('driver.label.noRecords')}</td>
                                </h6>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn btn-secondary"
                            onClick={() => this.handleReferralModel(false, null)}
                            title={t<string>('driver.button.close')}
                        >
                            <span>{t('driver.button.close')}</span>
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.balanceDetailModel.showModel}
                    onHide={() => this.handleBalanceModel(false, null)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('driver.label.balanceDetails')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.balanceDetailModel.details !== null &&
                        this.state.balanceDetailModel.details !== undefined ? (
                            <>
                                <table className="table table-bordered">
                                    <tr>
                                        <td>{t('driver.label.account_balance')}</td>
                                        <td className="balance">
                                            {getFormattedCurrencyWithSymbol(
                                                this.state.balanceDetailModel?.details?.account_balance,
                                                'text',
                                                undefined,
                                                this.state.balanceDetailModel.details.currency_details
                                                    ? this.state.balanceDetailModel.details.currency_details.symbol
                                                    : store?.getState()?.configuration?.default_currency?.symbol,
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{t('driver.label.rewards_balance')}</td>
                                        <td className="balance">
                                            {getFormattedCurrencyWithSymbol(
                                                this.state.balanceDetailModel?.details?.available_rewards_balance,
                                                'text',
                                                undefined,
                                                this.state.balanceDetailModel.details.currency_details
                                                    ? this.state.balanceDetailModel.details.currency_details.symbol
                                                    : store?.getState()?.configuration?.default_currency?.symbol,
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{t('driver.label.referral_balance')}</td>
                                        <td className="balance">
                                            {getFormattedCurrencyWithSymbol(
                                                this.state.balanceDetailModel?.details?.available_referral_balance,
                                                'text',
                                                undefined,
                                                this.state.balanceDetailModel.details.currency_details
                                                    ? this.state.balanceDetailModel.details.currency_details.symbol
                                                    : store?.getState()?.configuration?.default_currency?.symbol,
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{t('driver.label.current_balance')}</td>
                                        <td className="balance">
                                            {getFormattedCurrencyWithSymbol(
                                                this.state.balanceDetailModel?.details?.current_balance,
                                                'text',
                                                undefined,
                                                this.state.balanceDetailModel.details.currency_details
                                                    ? this.state.balanceDetailModel.details.currency_details.symbol
                                                    : store?.getState()?.configuration?.default_currency?.symbol,
                                            )}
                                        </td>
                                    </tr>
                                </table>
                                <div className="modal-title h4 mt-2" style={{ color: '#4f4f4f', fontWeight: '700' }}>
                                    {t('driver.label.pending_transactions_details')}
                                </div>

                                <table className="table table-bordered mt-2">
                                    <tr>
                                        <td>{t('driver.label.pending_balance')}</td>
                                        <td className="balance">
                                            {getFormattedCurrencyWithSymbol(
                                                this.state.balanceDetailModel?.details?.authorized_unsettled_balance,
                                                'text',
                                                undefined,
                                                this.state.balanceDetailModel.details.currency_details
                                                    ? this.state.balanceDetailModel.details.currency_details.symbol
                                                    : store?.getState()?.configuration?.default_currency?.symbol,
                                            )}
                                        </td>
                                    </tr>
                                </table>
                            </>
                        ) : (
                            <>
                                <h6>
                                    <td>{t('driver.label.noRecords')}</td>{' '}
                                </h6>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                className="btn btn-secondary"
                                onClick={() => this.handleBalanceModel(false, null)}
                                title={t<string>('driver.button.close')}
                            >
                                <span>{t('driver.button.close')}</span>
                            </Button>
                            {this.state.balanceDetailModel?.driverDetails?.status?.code ===
                                Common.DriverStatus.ENABLE ||
                            this.state.balanceDetailModel?.driverDetails?.status?.code ===
                                Common.DriverStatus.DISABLE ||
                            this.state.balanceDetailModel?.driverDetails?.status?.code ===
                                Common.DriverStatus.BAD_DEBTOR ? (
                                <Link
                                    to={{
                                        pathname: `/drivers/balance`,
                                    }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Button
                                        className="btn btn-info ml-2"
                                        title={t<string>('driver.button.amendBalance')}
                                        onClick={() => {
                                            localStorage.setItem('driverId', String(this.state.balanceDetailModel.id));
                                        }}
                                    >
                                        <span>{t('driver.button.amendBalance')}</span>
                                    </Button>
                                </Link>
                            ) : (
                                ''
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>
                {this.state.showRFIDCardModal && (
                    <RFIDCardsModal
                        t={t}
                        id={this.state.driverId!}
                        closeModal={this.closeModal}
                        showModal={this.state.showRFIDCardModal}
                    />
                )}
                {this.state.showCancelPendingTransactionsModal && (
                    <CancelPendingTransactionsModal
                        id={this.state.driverId!}
                        closeModal={this.closeCancelPendingTransactionsModal}
                        showModal={this.state.showCancelPendingTransactionsModal}
                        cancelPendingTransactions={this.cancelPendingTransactions}
                        t={t}
                    />
                )}
                <Modal show={this.state.showResetPasswordModal} onHide={() => this.closeResetPasswordModal()}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('driver.label.resetPassword')}</Modal.Title>
                    </Modal.Header>
                    <Formik
                        enableReinitialize
                        initialValues={this.state.passwordResetForm}
                        onSubmit={this.onConfirmResetPassword}
                        validationSchema={DriverPasswordResetValidationSchema(t)}
                    >
                        {(formik) => {
                            const { handleSubmit } = formik;
                            return (
                                <form onSubmit={handleSubmit} autoComplete="off">
                                    <Modal.Body>
                                        <Field
                                            type="password"
                                            name="password"
                                            id="password"
                                            autoComplete="off"
                                            placeholder={t('driver.label.password')}
                                            label={t('driver.label.password')}
                                            component={ReactstrapInput}
                                        />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className="btn-block clearfix ModelBtn">
                                            <button
                                                type="submit"
                                                className="btn btn-primary mr-2 mb-2"
                                                title={t<string>('driver.button.submit')}
                                            >
                                                <span>{t('driver.button.submit')}</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary mb-2"
                                                title={t<string>('driver.button.cancel')}
                                                onClick={this.closeResetPasswordModal}
                                            >
                                                <span>{t('driver.button.cancel')}</span>
                                            </button>
                                        </div>
                                    </Modal.Footer>
                                </form>
                            );
                        }}
                    </Formik>
                </Modal>
                {this.state.addNotesModal.showModal && (
                    <AddNotesModal
                        t={t}
                        showModal={this.state.addNotesModal.showModal}
                        driverDetails={this.state.addNotesModal.driverDetails}
                        closeModal={() => this.manageAddNotesModal(false)}
                    />
                )}
            </>
        );
    }
}

export default DriversGrid;
